import React from "react";
import "./quotation-pdf.css";

const formatCurrency = (value) => {
  const number = Number(value || 0);
  return number.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const QuotationPDF = ({ quotation }) => {
  const {
    companyName,
    companyAddress,
    companyPhone,
    companyEmail,
    logoPreview,
    customer,
    quoteNumber,
    quoteDate,
    dueDate,
    items,
    additionalDescription,
    subtotal,
    taxRate,
    taxAmount,
    discount,
    total,
  } = quotation;

  return (
    <div className="pdf-container">
      <div className="pdf-header">
        <div>
          <h1 className="pdf-company-name">
            {companyName} {quotation.companyShortName ? `(${quotation.companyShortName})` : ""}
          </h1>
          <p className="pdf-text">{companyAddress}</p>
          {companyPhone && <p className="pdf-text">Phone: {companyPhone}</p>}
          {companyEmail && <p className="pdf-text">Email: {companyEmail}</p>}
          {quotation.gstNumber && <p className="pdf-text strong">GST: {quotation.gstNumber}</p>}
        </div>
        {logoPreview && (
          <div className="pdf-logo-container">
            <img className="pdf-logo" src={logoPreview} alt="Company logo" />
          </div>
        )}
      </div>

      <div className="pdf-title-row">
        <h2 className="pdf-title">QUOTATION</h2>
      </div>

      <div className="pdf-meta-grid">
        <div>
          <p className="pdf-section-label">Bill To</p>
          <p className="pdf-text strong">{customer.name}</p>
          <p className="pdf-text">{customer.company}</p>
          <p className="pdf-text">{customer.phone}</p>
          <p className="pdf-text">{customer.email}</p>
          <p className="pdf-text">{customer.address}</p>
        </div>
        <div>
          <div className="pdf-meta-row">
            <span className="pdf-meta-label">Quote Number:</span>
            <span className="pdf-meta-value">{quoteNumber}</span>
          </div>
          <div className="pdf-meta-row">
            <span className="pdf-meta-label">Quote Date:</span>
            <span className="pdf-meta-value">{quoteDate}</span>
          </div>
          <div className="pdf-meta-row">
            <span className="pdf-meta-label">Due Date:</span>
            <span className="pdf-meta-value">{dueDate}</span>
          </div>
        </div>
      </div>

      <div className="pdf-divider" />

      {additionalDescription?.trim() && (
        <>
          <div className="pdf-description-block">
            <p className="pdf-section-label">Additional Description</p>
            <p className="pdf-text pdf-description-text">{additionalDescription.trim()}</p>
          </div>
          <div className="pdf-divider" />
        </>
      )}

      <table className="pdf-table">
        <thead>
          <tr>
            <th>Qty</th>
            <th>Description</th>
            <th>Unit Price</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => (
            <tr key={item.id || index}>
              <td>{item.quantity}</td>
              <td>{item.description}</td>
              <td>₹{formatCurrency(item.unitPrice)}</td>
              <td>₹{formatCurrency(item.amount)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pdf-divider" />

      <div className="pdf-footer-section">
        <div className="pdf-signature-block">
          <p className="pdf-text strong">Company Seal</p>
          {quotation.companySeal ? (
            <div className="pdf-seal-container">
              <img 
                src={quotation.companySeal} 
                alt="Company Seal" 
              />
            </div>
          ) : (
            <div className="pdf-signature-line" />
          )}
        </div>

        <div className="pdf-totals">
          <div className="pdf-total-row">
            <span>Subtotal</span>
            <span>₹{formatCurrency(subtotal)}</span>
          </div>
          <div className="pdf-total-row">
            <span>Tax ({taxRate}%)</span>
            <span>₹{formatCurrency(taxAmount)}</span>
          </div>
          <div className="pdf-total-row">
            <span>Discount</span>
            <span>₹{formatCurrency(discount)}</span>
          </div>
          <div className="pdf-total-row pdf-total-grand">
            <span>Total</span>
            <span>₹{formatCurrency(total)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotationPDF;
